import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RoundsConfiguration } from './interfaces/rounds_configuration';

@Injectable({
  providedIn: 'root'
})
export class RoundNotificationService {
  private roundCreatedSource = new Subject<RoundsConfiguration>();

  roundCreated$ = this.roundCreatedSource.asObservable();

  notifyRoundCreated(round: RoundsConfiguration) {
    this.roundCreatedSource.next(round);
  }
}
